module.exports = __webpack_public_path__ + "static/media/map-marker-question.b15c8d8a.svg";